import { DashboardMarketingCard } from 'cpes-common';
import { openInNewWindow, useAnalyticsActionTracker } from '@cp-shared-19/frontend-ui';
import { Button, Card } from '@vwfs-bronson/bronson-react';
import React, { MouseEvent } from 'react';
import { prependBrandInProduction } from 'utils/prependBrandInProduction';

type MarketingCardComponentProps = {
    content: DashboardMarketingCard;
    testId?: string;
    className?: string;
    buttonUrl?: string;
};

export const MarketingCardComponent: React.FC<MarketingCardComponentProps> = ({
    content,
    testId,
    className,
    buttonUrl,
}) => {
    const { onAction } = useAnalyticsActionTracker('onLearnMore');
    const { title, subtitle, image, text, buttonLabel } = content;

    const onButtonClick = (e: MouseEvent): void => {
        openInNewWindow(buttonUrl)(e);
        onAction(title);
    };

    if (!buttonUrl) return null;

    return (
        <Card
            title={title}
            subtitle={subtitle}
            imageSrc={prependBrandInProduction(image.href) || ''}
            footer
            testId={testId}
            className={className}
            buttons={
                <Button
                    link
                    icon="semantic-forward"
                    iconReversed
                    small
                    testId={`${testId}-button`}
                    onClick={e => {
                        e.preventDefault();
                        onButtonClick(e);
                    }}
                    href={buttonUrl}
                >
                    {buttonLabel}
                </Button>
            }
        >
            <div dangerouslySetInnerHTML={{ __html: text }} />
        </Card>
    );
};
